import { render, staticRenderFns } from "./SearchDropdownContent.vue?vue&type=template&id=dc736bf2&scoped=true"
import script from "./SearchDropdownContent.vue?vue&type=script&lang=js"
export * from "./SearchDropdownContent.vue?vue&type=script&lang=js"
import style0 from "./SearchDropdownContent.vue?vue&type=style&index=0&id=dc736bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc736bf2",
  null
  
)

export default component.exports